export default __webpack_public_path__ + "assets/pdf/Customer Instant Credit Application_ (082017).a9494be6.pdf";